import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Dialog, DialogContent, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { FiAlertTriangle } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import Btn from 'components/button';
import { commonStyles as styles } from 'assets/style';
import { delegateTypeState, toggleDeleteDelegate } from 'pages/user-preferences/store';
import style from 'pages/user-preferences/style';

export const ConfirmDeleteDelegateModal = ({ setDelegateList }) => {
    const [delegate, setDelegate] = useRecoilState(delegateTypeState);
    const [modal, setModal] = useRecoilState(toggleDeleteDelegate);
    const deleteApi = useMutation(() => axios.delete(`${endPoints?.staticLookups?.deleteDelegate({ delegateID: modal?.id, scheduleId: modal?.scheduleId })}`));

    const handleYes = () => {
        if (modal?.type === 'delete') deleteApi.mutate();
    };

    const handleNo = () => {
        setModal({ ...modal, isOpen: false });
    };

    React.useEffect(() => {
        if (deleteApi?.isSuccess) {
            setDelegate({ ...delegate, pageNumber: 1 });
            toast.success(deleteApi?.data?.messages?.[0]);
            setDelegateList((prevDelegateList) => prevDelegateList?.filter((delegates) => delegates.delegateId !== modal.id));
            setModal({ ...modal, isOpen: false });
        }
    }, [deleteApi?.isSuccess]);

    return (
        <Dialog
            open={modal?.isOpen}
            onClose={handleNo}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            data-testid="dialogModal"
        >
            <DialogContent
                sx={{
                    maxWidth: modal?.type === 'delete' ? '375px' : '450px',
                    border: (theme) => `10px solid ${theme.palette.border.$color_border_default}`,
                }}
            >
                {modal?.type === 'delete' && (
                    <>
                        <Box sx={style.deleteModal.deleteMsgWrap}>
                            {modal?.type === 'delete' && <FiAlertTriangle color="#d02424" size={70} />}
                            <Typography variant="h5">{modal?.message}</Typography>
                        </Box>

                        <Box sx={style.deleteModal.actionWrapper}>
                            <Btn
                                className="custom-btn"
                                display="flex"
                                alignitems="center"
                                variant="contained"
                                onClick={() => handleYes()}
                                data-testid="yes-btn"
                                sx={styles.modalSaveButton}
                            >
                                Yes {deleteApi?.isLoading && <CircularProgress sx={style.deleteModal.yesCircularProg} color="inherit" size={14} />}
                            </Btn>
                            <Btn
                                className="custom-btn"
                                variant="outlined"
                                sx={{ ...styles.modalCancelButton, marginLeft: '10px' }}
                                onClick={() => handleNo()}
                                layout="outline"
                                data-testid="no-btn"
                            >
                                No
                            </Btn>
                        </Box>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};

ConfirmDeleteDelegateModal.propTypes = {
    setDelegateList: PropTypes.func.isRequired,
};

export default ConfirmDeleteDelegateModal;
